/* This file was generated by running "node scripts/generateTranslations.js". */
/* Created: 2026-09-10 13:57:07 */

const Keys = {
  startingAt: 'startingAt',
  perAdult: 'perAdult',
  priceInfo: 'priceInfo'
}; export default Keys;